/** Raw TruDocs row shape from GET /buildings/GetBuildingDocuments/:id. */
export interface BuildingDocumentRaw {
  documentId: number;
  fileName: string;
  fileType: string;
  fileSize: number;
  uploadedBy: string;
  uploadDate?: string | Date | null;
  uploadedDate?: string | Date | null;
  floorNumber?: string | null;
  category?: string;
  url?: string;
}

/** Normalized document row consumed by DocumentsTab (PRD §09). */
export interface BuildingDocument {
  documentId: number;
  fileName: string;
  fileType: string;
  fileSize: number;
  uploadedBy: string;
  uploadedDate: string;
  category: string;
  url?: string;
}

function inferDocumentCategory(fileName: string, fileType: string): string {
  const name = fileName.toLowerCase();
  if (name.includes('lease')) return 'Leases';
  if (name.includes('floor') && (name.includes('plan') || fileType.includes('pdf'))) return 'Floor Plans';
  if (name.includes('survey')) return 'Surveys';
  if (name.includes('measurement') || name.includes('methodology') || name.includes('report')) return 'Reports';
  if (fileType.includes('spreadsheet') || fileType.includes('excel')) return 'Reports';
  return 'Other';
}

function normalizeUploadedDate(raw: string | Date | null | undefined): string {
  if (!raw) return '';
  if (raw instanceof Date) return raw.toISOString();
  return String(raw);
}

/** Map legacy GetBuildingDocuments rows into the tab's expected envelope. */
export function normalizeBuildingDocuments(raw: unknown): BuildingDocument[] {
  if (!Array.isArray(raw)) return [];
  return raw.map((row) => {
    const r = row as BuildingDocumentRaw;
    const fileName = r.fileName ?? '';
    const fileType = r.fileType ?? '';
    return {
      documentId: r.documentId,
      fileName,
      fileType,
      fileSize: r.fileSize ?? 0,
      uploadedBy: r.uploadedBy ?? '',
      uploadedDate: normalizeUploadedDate(r.uploadedDate ?? r.uploadDate),
      category: r.category ?? inferDocumentCategory(fileName, fileType),
      url: r.url,
    };
  });
}
